var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gpt-digital-human"},[(_vm.video)?_c('video',{ref:"video",attrs:{"src":_vm.video,"muted":""},domProps:{"muted":true},on:{"timeupdate":_vm.playing,"ended":_vm.resume}}):_vm._e(),_c('div',{staticClass:"status"})])}
var staticRenderFns = []

export { render, staticRenderFns }